<template lang="pug">
  .component-create-plan
    .row
      .columns
        label Name
          input(type="text", v-model="attribute.name")
      .columns
        label Description
        template(v-if="$route.params.hasOwnProperty('id')" )
          TranslateField(group="entities", :field="attribute._translatable.description", label="Description", :value="attribute.description")
            input.input-group-field(type="text", v-model="attribute.description")
        template(v-else)
          input(type="text", v-model="attribute.description")

    .row

      .columns.small-12.large-6
        label Type
          select(v-model="attribute.type")
            option number
            option string
        label Recommended &nbsp;
          input(type="checkbox", v-model="attribute.recommended")
        label Private &nbsp;
          input(type="checkbox", v-model="attribute.private")

      .columns.small-12.large-6
        label Vehicle type
        SelectizeVehicleType(@optionSelected="setVehicleType", :selectedValue="attribute.vehicle_type_id")
        label Icon
        SelectizeIcon(v-model="attribute.icon", value-field="iconName")
      .row.columns
        button.button(@click="createAttribute") Save
</template>
<script type="text/babel">

  import DatePicker from "../../components/structure/DatePicker";
  import SelectizeTocType from "../../components/structure/ui/lists/selectize/SelectizeTocType";
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import KeplerFileUpload from "../../components/structure/KeplerFileUpload";
  import MaggieHelper from "../../maggieHelper";
  import Editor from "../../components/structure/ui/Editor";
  import SelectizeVehicleType from "../../components/structure/ui/lists/selectize/SelectizeVehicleType";
  import SelectizeIcon from "../../components/structure/ui/lists/selectize/SelectizeIcon.vue";
  import TranslateField from "./TranslateField.vue";

  export default {
    name: "CreateVehicleAttribute",
    components: {
      TranslateField,
      SelectizeIcon, SelectizeVehicleType, Editor, KeplerFileUpload, SelectizeTocType, DatePicker},
    data() {
      return {
        attribute: {
          name: null,
          description: null,
          recommended: false,
          vehicle_type_id: null,
          type: null,
          icon: null,
          private: false,
        }
      }
    },
    computed: {},
    mounted() {
    },
    created() {
      if (this.$route.params.id) {
        KeplerBackofficeSdk.vehicleAttributes.select(this.$route.params.id).get((data) => {
          this.attribute = data
          this.attribute.vehicle_type_id = data.vehicle_type.id
        })
      }
    },
    methods: {
      setVehicleType(obj) {
        this.attribute.vehicle_type_id = obj.id
      },
      createAttribute() {
        if (this.$route.params.id) {
          KeplerBackofficeSdk.vehicleAttributes.select(this.attribute).edit(this.attribute, () => {
            MaggieHelper.notification('Edited', 'Vehicle attribute edited')
            this.$router.push({name: 'attributes'})
          })
          return
        }

        KeplerBackofficeSdk.vehicleAttributes.make(this.attribute, () => {
          MaggieHelper.notification('Created', 'Vehicle attribute created')
          this.$router.push({name: 'attributes'})
        })
      },

    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-create-plan
    background: white
    padding: 1em 2em

</style>



// WEBPACK FOOTER //
// CreateVehicleAttribute.vue?3948d5cb